import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: "https://rosseycakes.herokuapp.com/",
});
